import {BaseReadDataProvider} from "./BaseReadDataProvider";
import {
    SurveySessionExportOptions,
    SurveySessionExportResponse,
    SurveySessionListOptions,
    SurveySessionModel
} from "../model/SurveySessionModel";
import {BaseDataProviderAgent} from "./BaseDataProviderAgent";

export class SurveySessionDataProvider
    extends BaseReadDataProvider<SurveySessionModel, SurveySessionListOptions> {
    constructor() {
        super(`/survey/sessions`);
    }

    createExportTask =
        async (options: SurveySessionExportOptions):
            Promise<SurveySessionExportResponse> => {
            return BaseDataProviderAgent.send<SurveySessionExportResponse>(
                'post',
                `${this.baseUrl}/export`,
                options,);

        }

}